<div class="container">
  <ng-container>
    <app-p8-documents-error-page
      *ngIf="hasServerError || hasEmptyDoc"
      data-e2e = "cd-error-message"
      [messageHeader]="messageHeader"
      [messageBody]="messageBody"
    >
    </app-p8-documents-error-page>
  </ng-container>
  <dxo-card class="documents" *ngIf="!hasServerError && !hasEmptyDoc">
    <div class="loader-container" *ngIf="isLoading; else showDocuments">
      <dxo-circular-loader text="Loading..."></dxo-circular-loader>
    </div>
    <ng-template #showDocuments>
      <card-body>
        <div class="home-page-container">
          <ng-container>
            <div *ngFor="let coverage of coverageDocumentDataArray">
              <dxo-card bodyHeader="{{ coverage.coverageDescription }}" [attr.data-e2e-header]="coverage.coverageDescription">
                <app-document-group-page
                  [dataLength]="coverage.documentLength"
                  [componentData]="coverage.document"
                ></app-document-group-page>
              </dxo-card>
            </div>
          </ng-container>
        </div>
      </card-body>
    </ng-template>
  </dxo-card>
</div>
